import React from "react";
import Footer from "../Components/Footer";
import heroImage from "../assets/home_images/homepage-hero-img.webp";
import fishScaleRight from "../assets/home_images/hp-fish-scale-art-1.svg";
import fishScaleLeft from "../assets/home_images/hp-fish-scale-art-2.svg";
import dashboardImg from "../assets/home_images/dashboard.webp";
import mobileImg from "../assets/home_images/mobile.webp";
import cardImg from "../assets/home_images/card.webp";
import wealthImg from "../assets/home_images/wealth.webp";
import womenImg from "../assets/home_images/women.webp";
import sproutsLogo from "../assets/home_logos/sprouts-logo.webp";
import pacificLogo from "../assets/home_logos/pacific-bells-logo.webp";
import veraLogo from "../assets/home_logos/logo-vera.png.webp";
import lifetimeLogo from "../assets/home_logos/lifetime-logo.webp";
import gardaworldLogo from "../assets/home_logos/gardaworld-logo.webp";
import award1 from "../assets/awards/award1.webp";
import award2 from "../assets/awards/award2.webp";
import award3 from "../assets/awards/award3.webp";
import award4 from "../assets/awards/award4.webp";
import award5 from "../assets/awards/award5.webp";
import award6 from "../assets/awards/award6.webp";
import award7 from "../assets/awards/award7.webp";
import blog1 from "../assets/insights/blog1.webp";
import blog2 from "../assets/insights/blog2.webp";
import blog3 from "../assets/insights/blog3.webp";
import blog4 from "../assets/insights/blog4.webp";
import testimonialImg1 from "../assets/testimonial/img1.webp";
import testimonialImg2 from "../assets/testimonial/img2.webp";
import testimonialLogo1 from "../assets/testimonial/logo1.webp";

const customerLogos = [
  gardaworldLogo,
  lifetimeLogo,
  sproutsLogo,
  pacificLogo,
  veraLogo,
  gardaworldLogo,
  lifetimeLogo,
];

const partnerLogos = [sproutsLogo, pacificLogo, gardaworldLogo, lifetimeLogo, veraLogo];
const awards = [award1, award2, award3, award4, award5, award6, award7];

const posts = [
  {
    image: blog1,
    title: "Employee Burnout: Understanding, Preventing, and Managing Workplace Burnout",
  },
  {
    image: blog2,
    title: "How To Measure Employee Satisfaction: The Complete 2026 Guide",
  },
  {
    image: blog3,
    title: "Bi-Weekly Pay and Staff Retention in Healthcare",
  },
  {
    image: blog4,
    title: "The Ultimate Guide to Small Business Employee Benefits in 2026",
  },
];

function Home() {
  return (
    <>
      <style>{`
        .dp-home {
          background: #fff;
          color: #270001;
          overflow: hidden;
        }

        .dp-inner {
          margin: 0 auto;
          max-width: 1608px;
          padding-left: clamp(24px, 8.1vw, 156px);
          padding-right: clamp(24px, 8.1vw, 156px);
        }

        .dp-btn {
          background: #340001;
          border: 0;
          color: #fff;
          cursor: pointer;
          display: inline-flex;
          font: 800 20px/1 "Manrope", Arial, sans-serif;
          justify-content: center;
          padding: 19px 29px;
        }

        .dp-btn-orange {
          background: #ff4b14;
          color: #210000;
        }

        .dp-hero {
          min-height: 862px;
          padding-top: 110px;
          position: relative;
        }

        .dp-hero-title {
          margin: 0 auto;
          max-width: 1200px;
          position: relative;
          text-align: center;
          z-index: 2;
        }

        .dp-hero-title span:first-child {
          color: #2b0001;
          display: block;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: clamp(72px, 5vw, 98px);
          font-weight: 500;
          line-height: .92;
          margin: 0 auto;
        }

        .dp-hero-title span:last-child {
          color: #ff4b14;
          display: block;
          font-family: "Manrope", Arial, sans-serif;
          font-size: clamp(132px, 10vw, 190px);
          font-weight: 900;
          letter-spacing: -.04em;
          line-height: .8;
          margin: 8px auto 0;
          white-space: nowrap;
        }

        .dp-hero-bottom {
          display: block;
          margin-top: 72px;
          min-height: 410px;
          position: relative;
          z-index: 3;
        }

        .dp-hero-copy {
          margin-left: 162px;
          max-width: 520px;
          padding: 0 0 54px;
          position: relative;
          z-index: 4;
        }

        .dp-hero-copy p {
          color: #050505;
          font-family: "Manrope", Arial, sans-serif;
          font-size: 23px;
          font-weight: 500;
          line-height: 1.36;
          margin: 0 0 24px;
          max-width: 510px;
        }

        .dp-hero-copy p strong {
          font-weight: 900;
        }

        .dp-hero-media {
          height: auto;
          overflow: visible;
          position: absolute;
          left: 700px;
          top: -157px;
          width: min(61.875vw, 1188px);
          z-index: 5;
        }

        .dp-hero-media img {
          display: block;
          height: auto;
          max-width: none;
          width: 60%;
        }

        .dp-platform {
          padding: 94px 0 112px;
          position: relative;
        }

        .dp-platform-card {
          align-items: center;
          background: #3b0001;
          border-radius: 8px;
          display: grid;
          gap: 48px;
          grid-template-columns: minmax(360px, 780px) minmax(360px, 1fr);
          min-height: 348px;
          overflow: visible;
          padding: 0 88px 0 0;
          position: relative;
        }

        .dp-device-stack {
          height: 474px;
          margin-left: 36px;
          margin-top: -118px;
          position: relative;
        }

        .dp-device-phone {
          bottom: 0;
          left: 0;
          max-height: 474px;
          position: absolute;
          width: 330px;
          z-index: 3;
        }

        .dp-device-dashboard {
          border-radius: 6px;
          box-shadow: 0 16px 50px rgba(0, 0, 0, .16);
          left: 282px;
          position: absolute;
          top: 118px;
          width: 365px;
          z-index: 2;
        }

        .dp-device-card {
          left: 350px;
          position: absolute;
          top: 6px;
          width: 330px;
          z-index: 4;
        }

        .dp-platform-copy {
          color: #fff;
          font: 500 22px/1.42 "Manrope", Arial, sans-serif;
          max-width: 710px;
        }

        .dp-platform-copy p {
          margin: 0 0 36px;
        }

        .dp-logos {
          background: #fff;
          padding: 20px 0 132px;
          text-align: center;
        }

        .dp-logos h2 {
          color: #000;
          font: 900 25px/1.2 "Manrope", Arial, sans-serif;
          margin: 0 0 46px;
        }

        .dp-logo-row {
          align-items: center;
          display: flex;
          gap: 58px;
          justify-content: center;
        }

        .dp-logo-row img {
          max-height: 76px;
          max-width: 178px;
          object-fit: contain;
        }

        .dp-partner-row {
          align-items: center;
          border-bottom: 1px solid #cfcfcf;
          border-top: 1px solid #cfcfcf;
          display: flex;
          gap: 42px;
          justify-content: center;
          margin: 62px auto 0;
          max-width: 1278px;
          padding: 30px 0;
        }

        .dp-partner-row strong {
          color: #000;
          font: 900 19px/1 "Manrope", Arial, sans-serif;
          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .dp-partner-row img {
          max-height: 58px;
          max-width: 150px;
          object-fit: contain;
        }

        .dp-recruit,
        .dp-wealth {
          min-height: 762px;
          position: relative;
        }

        .dp-recruit-grid,
        .dp-wealth-grid {
          align-items: center;
          display: grid;
          gap: 70px;
          grid-template-columns: minmax(430px, 1fr) minmax(520px, 1.25fr);
        }

        .dp-section-title {
          color: #2b0001;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: clamp(56px, 4.7vw, 76px);
          font-weight: 500;
          line-height: 1.03;
          margin: 0;
        }

        .dp-section-copy {
          color: #050505;
          font: 600 22px/1.42 "Manrope", Arial, sans-serif;
          margin: 32px 0 30px;
          max-width: 700px;
        }

        .dp-photo-collage {
          display: grid;
          gap: 30px;
          grid-template-columns: 1fr 1fr;
          position: relative;
        }

        .dp-photo-collage img {
          height: 360px;
          object-fit: cover;
          width: 100%;
        }

        .dp-photo-collage img:first-child {
          margin-top: 140px;
        }

        .dp-stat {
          color: #ff4b14;
          font: 900 98px/1 "Manrope", Arial, sans-serif;
          margin: 26px 0 16px;
        }

        .dp-awards {
          padding: 110px 0 120px;
          position: relative;
          text-align: center;
        }

        .dp-fish-art {
          pointer-events: none;
          position: absolute;
          z-index: 0;
          opacity: .96;
        }

        .dp-fish-right {
          width: min(680px, 70vw);
          max-width: 720px;
          height: auto;
          object-fit: contain;
          right: -60px;
          top: 10px;
        }

        .dp-fish-left {
          width: min(700px, 70vw);
          max-width: 740px;
          height: auto;
          object-fit: contain;
          left: -110px;
          top: -40px;
        }

        .dp-fish-bottom {
          width: min(900px, 88vw);
          max-width: 920px;
          height: auto;
          object-fit: contain;
          right: -100px;
          bottom: -92px;
        }

        .dp-recruit .dp-inner,
        .dp-wealth .dp-inner,
        .dp-awards .dp-inner {
          position: relative;
          z-index: 1;
        }

        .dp-awards h2 {
          color: #050505;
          font: 900 30px/1.15 "Manrope", Arial, sans-serif;
          margin: 0 0 26px;
          position: relative;
          z-index: 1;
        }

        .dp-awards p {
          font: 500 22px/1.3 "Manrope", Arial, sans-serif;
          margin: 0 0 56px;
          position: relative;
          z-index: 1;
        }

        .dp-award-row {
          align-items: center;
          display: flex;
          gap: 52px;
          justify-content: center;
          position: relative;
          z-index: 1;
        }

        .dp-award-row img {
          max-height: 132px;
          max-width: 132px;
          object-fit: contain;
        }

        .dp-commit {
          background: #3b0001;
          color: #fff;
          padding: 98px 0 100px;
        }

        .dp-commit-grid {
          align-items: center;
          display: grid;
          gap: 86px;
          grid-template-columns: minmax(420px, 1fr) minmax(520px, 1fr);
        }

        .dp-kicker {
          align-items: center;
          display: flex;
          font: 900 20px/1 "Manrope", Arial, sans-serif;
          gap: 14px;
          letter-spacing: .06em;
          margin-bottom: 30px;
          text-transform: uppercase;
        }

        .dp-kicker::before {
          background: #ff4b14;
          content: "";
          height: 10px;
          width: 75px;
        }

        .dp-commit h2 {
          color: #fff;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: clamp(62px, 5vw, 84px);
          font-weight: 500;
          line-height: 1.03;
          margin: 0;
        }

        .dp-commit h2 strong {
          display: block;
          font-family: "Manrope", Arial, sans-serif;
          font-size: clamp(58px, 4.8vw, 82px);
          font-weight: 900;
          line-height: 1.05;
          margin-top: 18px;
        }

        .dp-commit p {
          font: 600 22px/1.5 "Manrope", Arial, sans-serif;
          margin: 110px 0 38px;
          max-width: 555px;
        }

        .dp-insights {
          background: #fff1e6;
          padding: 150px 0 126px;
        }

        .dp-insights-grid {
          align-items: center;
          display: grid;
          gap: 84px;
          grid-template-columns: minmax(390px, .85fr) minmax(620px, 1.15fr);
        }

        .dp-insights p {
          color: #050505;
          font: 500 23px/1.42 "Manrope", Arial, sans-serif;
          margin: 34px 0 32px;
          max-width: 680px;
        }

        .dp-workday-card {
          background: #3b0001;
          color: #fff;
          display: flex;
          font: 900 56px/1 "Manrope", Arial, sans-serif;
          gap: 46px;
          justify-content: center;
          padding: 146px 40px;
        }

        .dp-workday-card span:last-child {
          border-left: 2px solid rgba(255, 255, 255, .8);
          padding-left: 46px;
        }

        .dp-feature-title {
          color: #050505;
          font: 900 31px/1.25 "Manrope", Arial, sans-serif;
          margin: 42px 0 24px;
        }

        .dp-posts {
          background: #fff1e6;
          display: grid;
          gap: 58px 34px;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          padding: 50px clamp(24px, 8.1vw, 156px) 126px;
        }

        .dp-post img {
          border-top: 10px solid #ff4b14;
          height: 220px;
          object-fit: cover;
          width: 100%;
        }

        .dp-tag {
          background: #35dff3;
          border-radius: 4px;
          display: inline-flex;
          font: 800 16px/1 "Manrope", Arial, sans-serif;
          margin: 34px 0 24px;
          padding: 8px;
        }

        .dp-post h3 {
          color: #050505;
          font: 900 24px/1.32 "Manrope", Arial, sans-serif;
          margin: 0 0 24px;
        }

        .dp-link {
          color: #050505;
          font: 900 23px/1 "Manrope", Arial, sans-serif;
          text-decoration: none;
        }

        .dp-testimonial {
          padding: 120px 0 0;
        }

        .dp-testimonial h2 {
          margin-bottom: 60px;
        }

        .dp-testimonial-grid {
          display: grid;
          gap: 52px;
          grid-template-columns: minmax(420px, .8fr) minmax(720px, 1.2fr);
        }

        .dp-quote {
          color: #2b0001;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: clamp(34px, 2.9vw, 47px);
          font-weight: 500;
          line-height: 1.15;
          margin: 0 0 76px;
          max-width: 710px;
        }

        .dp-person {
          color: #050505;
          font: 800 21px/1.5 "Manrope", Arial, sans-serif;
          margin: 0 0 36px;
        }

        .dp-person span {
          display: block;
          font-weight: 500;
        }

        .dp-testimonial-logo {
          height: 68px;
          object-fit: contain;
          width: 126px;
        }

        .dp-testimonial-images {
          display: grid;
          gap: 28px;
          grid-template-columns: 1fr 1.4fr;
        }

        .dp-testimonial-images img {
          height: 520px;
          object-fit: cover;
          width: 100%;
        }

        .dp-choice {
          background: #3b0001;
          color: #fff;
          margin-top: 72px;
          overflow: hidden;
          padding: 136px 0 126px;
          position: relative;
        }

        .dp-choice-grid {
          display: grid;
          gap: 78px;
          grid-template-columns: minmax(390px, .75fr) minmax(720px, 1.25fr);
          position: relative;
          z-index: 1;
        }

        .dp-choice h2 {
          color: #fff;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: clamp(58px, 4.6vw, 78px);
          font-weight: 500;
          line-height: 1.04;
          margin: 0 0 42px;
        }

        .dp-choice-list {
          display: grid;
          gap: 48px 80px;
          grid-template-columns: 1fr 1fr;
        }

        .dp-choice-item {
          border-top: 10px solid #ff4b14;
          padding-top: 28px;
        }

        .dp-choice-item h3 {
          color: #ff4b14;
          font: 900 30px/1.12 "Manrope", Arial, sans-serif;
          margin: 0 0 30px;
        }

        .dp-choice-item p {
          color: #fff;
          font: 500 22px/1.4 "Manrope", Arial, sans-serif;
          margin: 0;
        }

        @media (max-width: 1200px) {
          .dp-hero-copy {
            padding-left: 24px;
          }

          .dp-hero-bottom,
          .dp-platform-card,
          .dp-recruit-grid,
          .dp-wealth-grid,
          .dp-commit-grid,
          .dp-insights-grid,
          .dp-testimonial-grid,
          .dp-choice-grid {
            grid-template-columns: 1fr;
          }

          .dp-hero-media {
            margin: 30px auto -90px;
            position: relative;
            right: auto;
            top: auto;
            width: min(118vw, 720px);
          }

          .dp-platform-card {
            padding: 44px 40px;
          }

          .dp-posts,
          .dp-choice-list {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 760px) {
          .dp-inner {
            padding-left: 18px;
            padding-right: 18px;
          }

          .dp-hero {
            min-height: auto;
            padding: 58px 0 54px;
          }

          .dp-hero-title span:last-child {
            font-size: 72px;
            white-space: normal;
          }

          .dp-hero-bottom {
            gap: 30px;
            margin-top: 36px;
          }

          .dp-hero-copy {
            margin-left: 0;
            padding: 0;
          }

          .dp-device-stack {
            display: none;
          }

          .dp-platform-card {
            display: block;
            padding: 34px 24px;
          }

          .dp-logo-row,
          .dp-partner-row,
          .dp-award-row {
            flex-wrap: wrap;
            gap: 24px;
          }

          .dp-photo-collage,
          .dp-posts,
          .dp-testimonial-images,
          .dp-choice-list {
            grid-template-columns: 1fr;
          }

          .dp-posts {
            padding-left: 18px;
            padding-right: 18px;
          }

          .dp-workday-card {
            font-size: 34px;
            padding: 74px 22px;
          }

          .dp-fish-right,
          .dp-fish-left,
          .dp-fish-bottom {
            opacity: .55;
            width: 280px;
          }
        }
      `}</style>

      <main className="dp-home">
        <section className="dp-hero">
          <div className="dp-inner">
            <h1 className="dp-hero-title">
              <span>The future</span>
              <span>of pay is here.</span>
            </h1>

            <div className="dp-hero-bottom">
              <div className="dp-hero-copy">
                <p>
                  Leave the old system behind with the platform that <strong>makes modern pay possible.</strong>
                </p>
                <p>
                  We modernize your payroll to give employees flexible access to their earned
                  wages with no cost or disruption to your business.
                </p>
                <button className="dp-btn" type="button">Get a Demo</button>
              </div>

              <div className="dp-hero-media">
                <img src={heroImage} alt="Smiling employee using DailyPay" />
              </div>
            </div>
          </div>
        </section>

        <section className="dp-platform">
          <div className="dp-inner">
            <div className="dp-platform-card">
              <div className="dp-device-stack" aria-hidden="true">
                <img className="dp-device-phone" src={mobileImg} alt="" />
                <img className="dp-device-dashboard" src={dashboardImg} alt="" />
                <img className="dp-device-card" src={cardImg} alt="" />
              </div>
              <div className="dp-platform-copy">
                <p>
                  Our Platform helps employers recruit, retain, and engage employees. In turn,
                  employees can build, earn, and grow their wealth. We&apos;re transforming how
                  the world gets paid so every worker can meet life&apos;s moments with confidence.
                </p>
                <button className="dp-btn dp-btn-orange" type="button">Explore Platform</button>
              </div>
            </div>
          </div>
        </section>

        <section className="dp-logos">
          <div className="dp-inner">
            <h2>Trusted by leading companies</h2>
            <div className="dp-logo-row">
              {customerLogos.map((logo, index) => (
                <img src={logo} alt="Company logo" key={`customer-${index}`} />
              ))}
            </div>
            <div className="dp-partner-row">
              <strong>Integration Partners</strong>
              {partnerLogos.map((logo, index) => (
                <img src={logo} alt="Integration partner" key={`partner-${index}`} />
              ))}
            </div>
          </div>
        </section>

        <section className="dp-recruit">
          <img className="dp-fish-art dp-fish-right" src={fishScaleRight} alt="" aria-hidden="true" />
          <div className="dp-inner dp-recruit-grid">
            <div>
              <h2 className="dp-section-title">Recruit, retain,<br />and engage employees</h2>
              <p className="dp-section-copy">
                We help employers like you stand out by giving your people a better way to access
                their pay.
              </p>
              <button className="dp-btn" type="button">Explore Benefits</button>
              <div className="dp-stat">80%</div>
              <p className="dp-section-copy">of workers say having on-demand pay influences their decision to join a company.</p>
            </div>
            <div className="dp-photo-collage">
              <img src={womenImg} alt="Employee at work" />
              <img src={wealthImg} alt="Employee smiling" />
            </div>
          </div>
        </section>

        <section className="dp-wealth">
          <img className="dp-fish-art dp-fish-left" src={fishScaleLeft} alt="" aria-hidden="true" />
          <div className="dp-inner dp-wealth-grid">
            <div className="dp-photo-collage">
              <img src={testimonialImg1} alt="Worker" />
              <img src={testimonialImg2} alt="Team member" />
            </div>
            <div>
              <h2 className="dp-section-title">Help them build, earn, and grow their wealth</h2>
              <p className="dp-section-copy">
                DailyPay&apos;s financial wellness empowers your employees to take control of their earnings.
              </p>
              <button className="dp-btn" type="button">See It in Action</button>
            </div>
          </div>
        </section>

        <section className="dp-awards">
          <img className="dp-fish-art dp-fish-bottom" src={fishScaleRight} alt="" aria-hidden="true" />
          <div className="dp-inner">
            <h2>Recognized as the Industry Leader</h2>
            <p>We&apos;re proud to have been honored with the following <u>awards.</u></p>
            <div className="dp-award-row">
              {awards.map((award, index) => (
                <img src={award} alt="Award" key={`award-${index}`} />
              ))}
            </div>
          </div>
        </section>

        <section className="dp-commit">
          <div className="dp-inner dp-commit-grid">
            <div>
              <div className="dp-kicker">Successful Implementation</div>
              <h2>Commitment to <strong>employee adoption</strong></h2>
            </div>
            <div>
              <p>
                We start by seamlessly integrating with your existing payroll systems, with no
                added work for your team. Then we&apos;re with you every step of the way, from
                technical setup and launch to employee activation, training, and beyond.
              </p>
              <button className="dp-btn dp-btn-orange" type="button">Integrate With Ease</button>
            </div>
          </div>
        </section>

        <section className="dp-insights">
          <div className="dp-inner dp-insights-grid">
            <div>
              <h2 className="dp-section-title">The insights you need,<br />when you need them</h2>
              <p>
                As the leader in on-demand pay, we&apos;re constantly pushing the industry
                forward. Explore the latest research, events, and more to see how we&apos;re
                building the path to modern pay solutions for all.
              </p>
              <button className="dp-btn" type="button">Explore Resources</button>
            </div>
            <div>
              <div className="dp-workday-card">
                <span>dailypay.</span>
                <span>workday</span>
              </div>
              <h3 className="dp-feature-title">
                DailyPay selected as Workday&apos;s strategic partner for On-Demand Pay
              </h3>
              <a className="dp-link" href="/">Learn more →</a>
            </div>
          </div>
        </section>

        <section className="dp-posts">
          {posts.map((post) => (
            <article className="dp-post" key={post.title}>
              <img src={post.image} alt={post.title} />
              <span className="dp-tag">Blog</span>
              <h3>{post.title}</h3>
              <a className="dp-link" href="/">Read more →</a>
            </article>
          ))}
        </section>

        <section className="dp-testimonial">
          <div className="dp-inner">
            <h2 className="dp-section-title">Business leaders<br /><span style={{ color: "#ff4b14", fontFamily: "Manrope, Arial, sans-serif", fontWeight: 900 }}>count on DailyPay</span></h2>
            <div className="dp-testimonial-grid">
              <div>
                <p className="dp-quote">
                  &quot;We couldn&apos;t be happier with the team we work with at DailyPay. Their
                  people are their true differentiator against other on-demand pay providers.&quot;
                </p>
                <p className="dp-person">
                  Taylor Leevers
                  <span>Special Projects Manager for Leevers Supermarkets, Inc.</span>
                </p>
                <img className="dp-testimonial-logo" src={testimonialLogo1} alt="Leevers" />
                <p style={{ marginTop: 90 }}>
                  <a className="dp-link" href="/">Read the case study →</a>
                </p>
              </div>
              <div className="dp-testimonial-images">
                <img src={testimonialImg1} alt="Worker close-up" />
                <img src={testimonialImg2} alt="Food service worker" />
              </div>
            </div>
          </div>
        </section>

        <section className="dp-choice">
          <div className="dp-inner dp-choice-grid">
            <div>
              <h2>Why top companies choose DailyPay</h2>
              <button className="dp-btn dp-btn-orange" type="button">Book a Demo</button>
            </div>
            <div className="dp-choice-list">
              <div className="dp-choice-item">
                <h3>Simple and secure for you</h3>
                <p>Minimal change to payroll processes.</p>
              </div>
              <div className="dp-choice-item">
                <h3>Empowering for employees</h3>
                <p>Greater financial control with access to earned pay to meet unexpected challenges.</p>
              </div>
              <div className="dp-choice-item">
                <p>Seamless integration with your HCM, payroll, banking and benefit applications.</p>
              </div>
              <div className="dp-choice-item">
                <p>No need for a pre-existing checking or savings account.</p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}

export default Home;
